import React, { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import Login from './Login';
import StudentDashboard from './StudentDashboard';
import InstructorDashboard from './InstructorDashboard';
import AdminDashboard from './AdminDashboard';
import ProgramBaskanDashboard from './ProgramBaskanDashboard';
import RectorDashboard from './RectorDashboard';
import { getToken, setToken, getUser, setUser } from './api';

const ADMIN_SESSION_KEY = 'adminSession';

function App() {
  const [user, setUserState] = useState(null);
  const [loading, setLoading] = useState(true);

  // Sayfa yüklendiğinde token kontrolü
  useEffect(() => {
    const token = getToken();
    const savedUser = getUser();
    
    if (token && savedUser) {
      // Token ve user bilgisi varsa state'e yükle
      setUserState(savedUser);
    } else {
      // Yoksa temizle
      setToken(null);
      setUser(null);
    }
    
    setLoading(false);
  }, []);

  const resetActivePages = () => {
    localStorage.removeItem('instructorActivePage');
    localStorage.removeItem('studentActivePage');
    localStorage.removeItem('adminActivePage');
    localStorage.removeItem('programBaskanActivePage');
    localStorage.removeItem('rectorActivePage');
  };

  const handleLogin = (loginData, options = {}) => {
    if (options.storeAdminSession && user?.userType === 'admin') {
      localStorage.setItem(ADMIN_SESSION_KEY, JSON.stringify(user));
    } else if (loginData?.userType === 'admin') {
      localStorage.removeItem(ADMIN_SESSION_KEY);
    }

    // Token ve user bilgisini localStorage'a kaydet
    setToken(loginData.token);
    setUser(loginData);
    setUserState(loginData);
    // Login sonrası her zaman Ana Sayfa'dan başla
    resetActivePages();
    console.log('Giriş yapıldı:', loginData);
  };

  const handleImpersonation = (loginData) => {
    handleLogin(loginData, { storeAdminSession: true });
  };

  const handleReturnToAdmin = () => {
    const savedAdminSession = localStorage.getItem(ADMIN_SESSION_KEY);
    if (!savedAdminSession) return;

    try {
      const adminSession = JSON.parse(savedAdminSession);
      setToken(adminSession.token);
      setUser(adminSession);
      setUserState(adminSession);
      localStorage.removeItem(ADMIN_SESSION_KEY);
      resetActivePages();
    } catch (error) {
      localStorage.removeItem(ADMIN_SESSION_KEY);
    }
  };

  const handleLogout = () => {
    // Token ve user bilgisini temizle
    setToken(null);
    setUser(null);
    setUserState(null);
    localStorage.removeItem(ADMIN_SESSION_KEY);
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        Yükleniyor...
      </div>
    );
  }

  if (!user) {
    return <Login onLogin={handleLogin} />;
  }

  // Kullanıcı tipine göre doğru dashboard'u göster
  return (
    <BrowserRouter>
      {user.impersonation?.active && (
        <div className="impersonation-banner">
          <span>
            Admin olarak {user.user?.name || user.user?.student_number || 'kullanıcı'} hesabındasınız.
          </span>
          <button type="button" onClick={handleReturnToAdmin}>
            Admin hesabına dön
          </button>
        </div>
      )}
      {user.userType === 'student' ? (
        <StudentDashboard
          user={user.user}
          onLogout={handleLogout}
          isImpersonating={Boolean(user.impersonation?.active)}
          onReturnToAdmin={handleReturnToAdmin}
        />
      ) : user.userType === 'admin' ? (
        <AdminDashboard user={user.user} onLogout={handleLogout} onImpersonate={handleImpersonation} />
      ) : user.userType === 'program_baskan' ? (
        <ProgramBaskanDashboard
          user={user.user}
          onLogout={handleLogout}
          isImpersonating={Boolean(user.impersonation?.active)}
          onReturnToAdmin={handleReturnToAdmin}
        />
      ) : (user.userType === 'rektor' || user.userType === 'rektor_yardimcisi') ? (
        <RectorDashboard
          user={user.user}
          userType={user.userType}
          onLogout={handleLogout}
          isImpersonating={Boolean(user.impersonation?.active)}
          onReturnToAdmin={handleReturnToAdmin}
        />
      ) : (
        <InstructorDashboard
          user={user.user}
          onLogout={handleLogout}
          isImpersonating={Boolean(user.impersonation?.active)}
          onReturnToAdmin={handleReturnToAdmin}
        />
      )}
    </BrowserRouter>
  );
}

export default App;

